function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M35.9,29.8h-8.2v14.3h7.9c1.7,0,2.9-0.6,3.8-1.9c0.8-1.3,1.3-3.2,1.3-5.6c0-2.2-0.4-3.8-1.2-5 C38.7,30.4,37.5,29.8,35.9,29.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M72.3,33.2c-0.2-1.7-0.4-2.8-0.4-3.3h-0.2c-0.1,0.6-0.2,1.7-0.5,3.4c-0.2,1.7-0.5,3.2-0.7,4.3l-4.1,19h10.8 l-4.1-19C72.7,36.4,72.5,34.9,72.3,33.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M125.2,8.1H26.5c-8.9,0-16.2,7.2-16.2,16.2v47.3c0,8.9,7.2,16.2,16.2,16.2h98.7c8.9,0,16.2-7.2,16.2-16.2V24.3 C141.4,15.3,134.2,8.1,125.2,8.1z M43.8,77.2l-7.5-20.5c-0.7-1.9-2.5-3.2-4.6-3.2h-4v23.7h-7.2V20.4h16c3.8,0,6.7,1.5,8.7,4.5 s3,6.9,3,11.8c0,3.4-0.6,6.4-1.7,9c-1.1,2.5-2.7,4.4-4.7,5.6l9.7,26L43.8,77.2L43.8,77.2z M81.6,77.2L79.1,66H64.2l-2.4,11.2h-7.3 l13-56.9h8.8l13,56.9H81.6z M123.7,77.2h-7.5L110.8,41c-0.2-1.2-0.4-2.7-0.5-4.5c-0.2-1.8-0.3-3-0.3-3.5h-0.2 c0,0.6-0.1,1.9-0.3,3.7c-0.2,1.9-0.3,3.3-0.5,4.3l-5.3,36.2h-7.5l-8.6-56.9H95l4.8,35c0.2,1.1,0.3,2.5,0.5,4.3s0.3,3,0.3,3.6h0.2 c0-0.6,0.1-1.8,0.3-3.7c0.2-1.8,0.3-3.3,0.5-4.3l4.8-35h8.4l4.8,35c0.2,1.4,0.3,3,0.5,4.6s0.3,2.7,0.3,3.4h0.2 c0-0.6,0.1-1.7,0.3-3.5c0.2-1.8,0.3-3.3,0.5-4.4l4.9-35h6.4L123.7,77.2z"
}));

var SvgRawIcon = function SvgRawIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 96.1",
    style: {
      enableBackground: "new 0 0 150 96.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRawIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/raw-icon.40b20649.svg";
export { ForwardRef as ReactComponent };